var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusBaseIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.33335C10.6667 5.49239 9.17431 4 7.33335 4C5.49239 4 4 5.49239 4 7.33335C4 9.17431 5.49239 10.6667 7.33335 10.6667C9.17431 10.6667 10.6667 9.17431 10.6667 7.33335Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.666C20.0001 14.825 18.5077 13.3326 16.6667 13.3326C14.8257 13.3326 13.3334 14.825 13.3334 16.666C13.3334 18.507 14.8257 19.9993 16.6667 19.9993C18.5077 19.9993 20.0001 18.507 20.0001 16.666Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16.666C10.6667 14.825 9.17431 13.3326 7.33335 13.3326C5.49239 13.3326 4 14.825 4 16.666C4 18.507 5.49239 19.9993 7.33335 19.9993C9.17431 19.9993 10.6667 18.507 10.6667 16.666Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 4V10.6667M20.0001 7.33335H13.3334",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBaseIc);
export default __webpack_public_path__ + "static/media/status_base_ic.aac567258df7d11867229e8ca712e1ab.svg";
export { ForwardRef as ReactComponent };